import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { ConsumerReviewsEntities } from 'client/data/models/consumer-reviews';
import { FormField } from 'site-modules/shared/components/form-field/form-field';
import { RatingStarsInput } from 'site-modules/shared/components/rating-stars-input/rating-stars-input';
import { ADDITIONAL_RATINGS } from 'site-modules/shared/constants/write-review/write-review';

function getFieldsComponents(fields, fieldRef, validate, reviewData) {
  return (
    <Col xs={12} md={4}>
      {fields.map(({ label, name }) => (
        <FormField
          key={name}
          labelClassName="heading-5 mb-0_5"
          className="mb-1_5"
          ref={fieldRef}
          tag={RatingStarsInput}
          label={label}
          name={name}
          id={name}
          onBlur={validate}
          onChange={validate}
          defaultValue={get(reviewData, `${name}Dto.${name}`)}
        />
      ))}
    </Col>
  );
}

export function AdditionalRatings({ fieldRef, validate, reviewData = null }) {
  return (
    <Row className="mb-2">
      <Col xs={12} className="heading-4 mb-1_5">
        Additional ratings
      </Col>
      {getFieldsComponents(ADDITIONAL_RATINGS.FIELDS_1, fieldRef, validate, reviewData)}
      {getFieldsComponents(ADDITIONAL_RATINGS.FIELDS_2, fieldRef, validate, reviewData)}
    </Row>
  );
}

AdditionalRatings.propTypes = {
  fieldRef: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  reviewData: ConsumerReviewsEntities.ReviewData,
};
